module.exports = __webpack_public_path__ + "assets/2924b53be356fc4aa30b007a2903ad48.png";